export const formGroup = {
  leasingId: { value: "", mandatory: true },
  leasingName: { value: "", mandatory: true },
  abbreviatedName: { value: "", mandatory: true },
  leasingAddress: { value: "", mandatory: true },
  provinceId: { value: "", mandatory: true },
  kabkotId: { value: "", mandatory: true },
  kecamatanId: { value: "", mandatory: true },
  zipCode: { value: "", mandatory: true },
  listKodeCabang: { value: [], mandatory: true },
  kelurahanId: { value: "" },
  leasingApiUrl: { value: "" },
  leasingSecretKey: { value: "" },
  leasingTokenUrl: { value: "" },
  groupLeasing: {value:"", mandatory: true}
};
